export default "__VITE_ASSET__OFOoTRMu__"